export const listboxTheme = {
  colorScheme: {
    light: {
      option: {
        selectedBackground: "{primary.400}",
        selectedColor: "{surface.0}",
      },
    },
  },
};
